var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconarrowCercleRightGreenEmpty(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Icon_ionic-ios-arrow-dropdown",
    "data-name": "Icon ionic-ios-arrow-dropdown",
    xmlns: "http://www.w3.org/2000/svg",
    width: 19.377,
    height: 19.377,
    viewBox: "0 0 19.377 19.377",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_63",
    "data-name": "Trac\\xE9 63",
    d: "M10.245,14.679a.9.9,0,0,0,0,1.272L14.7,20.395a.9.9,0,0,0,1.239.028l4.392-4.378a.9.9,0,1,0-1.267-1.272l-3.773,3.717-3.778-3.815A.9.9,0,0,0,10.245,14.679Z",
    transform: "translate(-5.605 -7.101)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_64",
    "data-name": "Trac\\xE9 64",
    d: "M3.375,13.063a9.688,9.688,0,1,0,9.688-9.688A9.687,9.687,0,0,0,3.375,13.063ZM18.858,7.269A8.195,8.195,0,1,1,7.269,18.858,8.195,8.195,0,1,1,18.858,7.269Z",
    transform: "translate(-3.375 -3.375)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconarrowCercleRightGreenEmpty);
export default __webpack_public_path__ + "static/media/Icon arrow-cercle-right-green-empty.c21491741b07a486338198c69f42f4bf.svg";
export { ForwardRef as ReactComponent };